<template>
    <modal @close="clearSelectedItem" dialog="modal-lg" class="dark-top" :footer="false">
        <div slot="title" v-if="getSelectedItem">
            <h2>Product details</h2>
            <h3>{{ getSelectedItem.name }}</h3>
        </div>

        <div slot="title" v-else>
            <h2>New Product</h2>
        </div>

        <div slot="body">
            <tabs>
                <tab name="Details">
                    <product-edit></product-edit>
                </tab>
                <tab name="Schedule">
                    <product-schedule></product-schedule>
                </tab>
                <tab name="Prices">
                    <product-prices></product-prices>
                </tab>
                <tab name="Extras">
                    <product-extras></product-extras>
                </tab>
                <tab name="Payments">
                    <product-payments></product-payments>
                </tab>
            </tabs>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import ProductEdit from '@/components/inventory/products/ProductEdit'
    import ProductSchedule from '@/components/inventory/products/ProductSchedule'
    import ProductPrices from '@/components/inventory/products/ProductPrices'
    import ProductExtras from '@/components/inventory/products/ProductExtras'
    import ProductResources from '@/components/inventory/products/ProductResources'

    export default {
        methods: {
            ...mapActions([
                'clearSelectedItem'
            ]),
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
            ])
        },
        components: {
            Modal,
            ProductEdit,
            ProductSchedule,
            ProductPrices,
            ProductExtras,
            ProductResources,
        }
    }
</script>



// WEBPACK FOOTER //
// ProductView.vue?08433850